<ng-container *ngIf="dataState$ | async as dataState">
  <div
    class="installations-wrapper"
    [ngClass]="{ 'hide-results': !dataState.installations || !dataState.installations?.length }"
  >
    <h2 class="search-results-label">{{ '+SEARCH.RESULT_LIST.SEARCH_RESULT' | translate }}</h2>

    <app-infinite-scroll
      [state$]="dataState$"
      [search$]="searchService.search$"
      [itemSize]="itemSize"
      (fetchNext)="onFetchNextInstallations($event)"
      [(nextBatch)]="nextBatch"
      (nextBatchChange)="onNextBatchChange($event)"
      [limit]="50"
    >
      <cdk-virtual-scroll-viewport
        [style.height.px]="getViewportHeight(dataState?.installations?.length, itemSize, 10)"
        [itemSize]="itemSize"
      >
        <ng-container *ngIf="searchedGateway$ | async as gateways">
          <ng-container *ngFor="let gateway of gateways">
            <vi-panel
              data-at-installation
              gtm="onGoToPage"
              gtmAction="Installation"
              gtmCategory="search"
              (click)="navigateToInstallations(gateway)"
            >
              <div content class="boxes flex flex-row flex-wrap gap-[17px] lt-md:gap-[6px]">
                <vi-box data-at-installation-not-registered>
                  <vi-icon icon name="gateway-date" [size]="20"></vi-icon>
                  <vi-item
                    item
                    [class.not-registered]="!gateway?.registeredAt"
                    data-at-item
                    size="medium"
                    [title]="'+SEARCH.SEARCH_BY_GATEWAY.REGISTERED_DATE' | translate"
                    [value]="
                      gateway?.registeredAt
                        ? (gateway?.registeredAt | date: 'short')
                        : ('+SEARCH.SEARCH_BY_GATEWAY.NOT_REGISTERED' | translate)
                    "
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-serial-number>
                  <vi-icon icon name="gateway-heatbox" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+SEARCH.SEARCH_BY_GATEWAY.COMMUNICATION_MODULE.LABEL' | translate"
                    [value]="gateway?.serial"
                    [disableNumberFormatting]="true"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-firmware-version>
                  <vi-icon icon name="gateway-firmware" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+INSTALLATIONS.INSTALLATION.FIRMWARE_VERSION.TITLE' | translate"
                    [value]="gateway?.version"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-last-status-changed>
                  <vi-icon icon name="gateway-date" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+INSTALLATIONS.INSTALLATION.LAST_STATUS_CHANGED' | translate"
                    [value]="gateway?.lastStatusChangedAt | date: 'short'"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-created-at>
                  <vi-icon icon name="gateway-date" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+INSTALLATIONS.INSTALLATION.CREATED_AT' | translate"
                    [value]="gateway?.createdAt | date: 'short'"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-produced-at>
                  <vi-icon icon name="gateway-date" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+INSTALLATIONS.INSTALLATION.PRODUCED_AT' | translate"
                    [value]="gateway?.producedAt | date: 'short'"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-status>
                  <vi-icon icon name="gateway-status" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+INSTALLATIONS.INSTALLATION.STATUS.TITLE' | translate"
                    [value]="gateway?.aggregatedStatus | translateAggregatedStatus"
                  ></vi-item>
                </vi-box>
                <vi-box data-at-installation-type>
                  <vi-icon icon name="gateway-heatbox" [size]="20"></vi-icon>
                  <vi-item
                    item
                    data-at-item
                    size="medium"
                    [title]="'+SEARCH.RESULT_LIST.LABEL.TYPE' | translate"
                    [value]="gateway?.gatewayType"
                  ></vi-item>
                </vi-box>
              </div>
            </vi-panel>
          </ng-container>
        </ng-container>

        <vi-loader
          *ngIf="nextBatch"
          [isLoading]="true"
          [message]="'+SEARCH.RESULT_LIST.FETCHING_MORE_RESULTS' | translate"
        ></vi-loader>
      </cdk-virtual-scroll-viewport>
    </app-infinite-scroll>
  </div>

  <vi-no-results
    imgPath="assets/img/search-guy.png"
    *ngIf="dataState.loaded && (!dataState.installations || !dataState?.installations?.length)"
  >
    {{ '+SEARCH.RESULT_LIST.GATEWAY_NOT_FOUND' | translate }}
  </vi-no-results>
</ng-container>
